__turbopack_context__.v({
  "className": "martian_mono_9289334e-module__WNz3Vq__className",
});
